import React from "react";
import PrivateNativeDate from "../PrivateNativeDate";
function TimePicker({ ...props }) {
    return React.createElement(PrivateNativeDate, { type: "time", ...props });
}
export default TimePicker;
//# sourceMappingURL=TimePicker.js.map